"use strict";

(function () {
  const SWATCH_SELECTOR =
    '.js-color-swatches input[type="radio"][data-variant-id]';

  const IMAGE_WIDTHS = [360, 533, 720, 940, 1066];

  const VARIANT_TRANSFER_KEY_PREFIX =
    "sd-product-variant:";

  if (window.__sofaDreamsProductCardSwatchesInitialized) {
    return;
  }

  window.__sofaDreamsProductCardSwatchesInitialized = true;

  const productCache = new Map();

  function getAbsoluteUrl(src) {
    if (!src) {
      return "";
    }

    try {
      return new URL(src, window.location.href).href;
    } catch (error) {
      return src;
    }
  }

  function getImageUrlWithWidth(src, width) {
    if (!src) {
      return "";
    }

    try {
      const imageUrl = new URL(src, window.location.href);

      imageUrl.searchParams.set("width", String(width));

      return imageUrl.href;
    } catch (error) {
      return src;
    }
  }

  function getWidthFromUrl(src, fallbackWidth) {
    try {
      const imageUrl = new URL(src, window.location.href);
      const width = parseInt(
        imageUrl.searchParams.get("width"),
        10
      );

      if (Number.isFinite(width) && width > 0) {
        return width;
      }
    } catch (error) {
      // Fallback verwenden
    }

    return fallbackWidth;
  }

  function generateSrcset(src, sourceWidth) {
    if (!src || !sourceWidth) {
      return "";
    }

    return IMAGE_WIDTHS
      .filter(function (width) {
        return width <= sourceWidth;
      })
      .map(function (width) {
        return (
          getImageUrlWithWidth(src, width) +
          " " +
          width +
          "w"
        );
      })
      .join(", ");
  }

  function getImageIdentity(src) {
    if (!src) {
      return "";
    }

    try {
      const imageUrl = new URL(src, window.location.href);

      imageUrl.searchParams.delete("width");

      return (
        imageUrl.hostname +
        imageUrl.pathname +
        imageUrl.search
      );
    } catch (error) {
      return src;
    }
  }

  function getCurrentImageRatio(image) {
    if (!image) {
      return 1.5;
    }

    const width =
      parseInt(image.getAttribute("width"), 10) ||
      image.naturalWidth ||
      image.clientWidth;

    const height =
      parseInt(image.getAttribute("height"), 10) ||
      image.naturalHeight ||
      image.clientHeight;

    if (!width || !height) {
      return 1.5;
    }

    return width / height;
  }

  function createImageElement(imageData, primaryImage) {
    const sourceWidth =
      parseInt(imageData.width, 10) ||
      getWidthFromUrl(imageData.src, 1200);

    const sourceHeight =
      parseInt(imageData.height, 10) || 0;

    let ratio = 0;

    if (sourceWidth && sourceHeight) {
      ratio = sourceWidth / sourceHeight;
    }

    if (!ratio || !Number.isFinite(ratio)) {
      ratio = getCurrentImageRatio(primaryImage);
    }

    const outputWidth = Math.min(
      sourceWidth || 1066,
      1066
    );

    const outputHeight = Math.max(
      1,
      Math.round(outputWidth / ratio)
    );

    const newImage = new Image(
      outputWidth,
      outputHeight
    );

    newImage.className = primaryImage.className;
    newImage.alt =
      imageData.alt ||
      primaryImage.alt ||
      "";

    /*
     * Wichtig:
     * Das Bild wird nach einer Nutzerinteraktion benötigt.
     * Deshalb nicht lazy laden.
     */
    newImage.loading = "eager";
    newImage.decoding = "async";
    newImage.fetchPriority = "high";

    if (primaryImage.sizes) {
      newImage.sizes = primaryImage.sizes;
    }

    const currentStyle =
      primaryImage.getAttribute("style");

    if (currentStyle) {
      newImage.setAttribute(
        "style",
        currentStyle
      );
    }

    const srcset = generateSrcset(
      imageData.src,
      sourceWidth || 1066
    );

    if (srcset) {
      newImage.srcset = srcset;
    }

    newImage.src = getImageUrlWithWidth(
      imageData.src,
      outputWidth
    );

    return newImage;
  }

  function removeSecondaryImage(wrapper) {
    const secondaryPicture =
      wrapper.querySelector(
        ".product-card__secondary-picture"
      );

    if (secondaryPicture) {
      secondaryPicture.remove();
      return;
    }

    const secondaryImage =
      wrapper.querySelector(".media--second");

    if (secondaryImage) {
      secondaryImage.remove();
    }
  }

  function waitForImage(image) {
    if (image.complete && image.naturalWidth > 0) {
      return Promise.resolve();
    }

    return new Promise(function (resolve) {
      let completed = false;

      function finish() {
        if (completed) {
          return;
        }

        completed = true;
        resolve();
      }

      image.addEventListener("load", finish, {
        once: true
      });

      image.addEventListener("error", finish, {
        once: true
      });

      /*
       * Verhindert, dass der Bildwechsel bei einem Browserproblem
       * dauerhaft hängen bleibt.
       */
      window.setTimeout(finish, 1200);
    });
  }

  async function replacePrimaryImage(
    wrapper,
    input,
    imageData
  ) {
    const primaryImage =
      wrapper.querySelector("img.media--first");

    if (
      !primaryImage ||
      !imageData ||
      !imageData.src
    ) {
      return;
    }

    const variantId = String(
      input.dataset.variantId || ""
    );

    const newImage = createImageElement(
      imageData,
      primaryImage
    );

    if (
      getImageIdentity(primaryImage.currentSrc || primaryImage.src) ===
      getImageIdentity(newImage.src)
    ) {
      removeSecondaryImage(wrapper);
      return;
    }

    /*
     * Bild vorladen, aber niemals unbegrenzt warten.
     */
    await waitForImage(newImage);

    if (
      wrapper.dataset.selectedVariantId !==
      variantId
    ) {
      return;
    }

    if (!primaryImage.isConnected) {
      return;
    }

    primaryImage.replaceWith(newImage);
    removeSecondaryImage(wrapper);

    if (typeof newImage.animate === "function") {
      newImage.animate(
        {
          opacity: [0, 1]
        },
        {
          duration: 180,
          easing: "ease-out"
        }
      );
    }
  }

  function getCleanProductUrl(
    wrapper,
    fallbackUrl
  ) {
    const configuredUrl =
      wrapper.dataset.productUrl || fallbackUrl || "";

    if (!configuredUrl) {
      return "";
    }

    try {
      const url = new URL(
        configuredUrl,
        window.location.origin
      );

      url.searchParams.delete("variant");
      url.searchParams.delete("option_values");
      url.hash = "";

      return url.pathname + url.search;
    } catch (error) {
      return configuredUrl.split("?")[0].split("#")[0];
    }
  }

  function updateProductLinks(
    wrapper,
    fallbackUrl
  ) {
    const cleanProductUrl = getCleanProductUrl(
      wrapper,
      fallbackUrl
    );

    if (!cleanProductUrl) {
      return;
    }

    wrapper
      .querySelectorAll(
        [
          ".js-color-swatches-link",
          ".card__title a.full-unstyled-link"
        ].join(",")
      )
      .forEach(function (link) {
        link.setAttribute(
          "href",
          cleanProductUrl
        );
      });
  }

  function setSelectedVariantImageData(wrapper, imageData) {
    if (!wrapper) {
      return;
    }

    if (!imageData || !imageData.src) {
      delete wrapper.dataset.selectedVariantImage;
      delete wrapper.dataset.selectedVariantImageWidth;
      delete wrapper.dataset.selectedVariantImageHeight;
      delete wrapper.dataset.selectedVariantImageAlt;
      return;
    }

    wrapper.dataset.selectedVariantImage =
      getAbsoluteUrl(imageData.src);
    wrapper.dataset.selectedVariantImageWidth = String(
      parseInt(imageData.width, 10) ||
      getWidthFromUrl(imageData.src, 1800)
    );
    wrapper.dataset.selectedVariantImageHeight = String(
      parseInt(imageData.height, 10) || 0
    );
    wrapper.dataset.selectedVariantImageAlt =
      imageData.alt || "";
  }

  function storeVariantTransfer(wrapper) {
    if (
      !wrapper ||
      wrapper.dataset.variantTransferEnabled !== "true"
    ) {
      return;
    }

    const handle = wrapper.dataset.product || "";
    const variantId =
      wrapper.dataset.selectedVariantId || "";

    if (!handle || !variantId) {
      return;
    }

    const payload = {
      variantId: String(variantId),
      createdAt: Date.now(),
      sourcePath: window.location.pathname
    };

    const imageUrl =
      wrapper.dataset.selectedVariantImage || "";

    if (imageUrl) {
      payload.image = {
        src: imageUrl,
        width: parseInt(
          wrapper.dataset.selectedVariantImageWidth,
          10
        ) || 1800,
        height: parseInt(
          wrapper.dataset.selectedVariantImageHeight,
          10
        ) || 0,
        alt:
          wrapper.dataset.selectedVariantImageAlt || ""
      };
    }

    try {
      window.sessionStorage.setItem(
        VARIANT_TRANSFER_KEY_PREFIX + handle,
        JSON.stringify(payload)
      );
    } catch (error) {
      // Navigation bleibt auch ohne Storage voll funktionsfaehig.
    }
  }

  function prepareVariantTransfer(event) {
    if (
      event.type === "pointerdown" &&
      event.button !== 0 &&
      event.button !== 1
    ) {
      return;
    }

    if (!(event.target instanceof Element)) {
      return;
    }

    const link = event.target.closest(
      [
        ".js-color-swatches-link",
        ".card__title a.full-unstyled-link"
      ].join(",")
    );

    if (!link) {
      return;
    }

    const wrapper = link.closest(
      ".js-color-swatches-wrapper"
    );

    if (!wrapper) {
      return;
    }

    updateProductLinks(wrapper, link.href);
    storeVariantTransfer(wrapper);
  }

  document.addEventListener(
    "pointerdown",
    prepareVariantTransfer,
    true
  );

  document.addEventListener(
    "click",
    prepareVariantTransfer,
    true
  );

  function updateQuickAdd(
    wrapper,
    variantId,
    available
  ) {
    const addToCartContainer =
      wrapper.querySelector(
        ".card__add-to-cart"
      );

    if (!addToCartContainer) {
      return;
    }

    const variantInput =
      addToCartContainer.querySelector(
        'input[name="id"]'
      );

    const addButton =
      addToCartContainer.querySelector(
        'button[name="add"]'
      );

    if (variantInput) {
      variantInput.value = variantId;
      variantInput.disabled = !available;
    }

    if (!addButton) {
      return;
    }

    addButton.disabled = !available;

    addButton.setAttribute(
      "aria-disabled",
      available ? "false" : "true"
    );

    const normalText =
      addButton.querySelector(
        ".card__quickview-text"
      );

    const soldOutText =
      addButton.querySelector(
        ".sold-out-message"
      );

    if (normalText) {
      normalText.classList.toggle(
        "hidden",
        !available
      );
    }

    if (soldOutText) {
      soldOutText.classList.toggle(
        "hidden",
        available
      );
    }
  }

  function fetchProduct(handle) {
    if (!handle) {
      return Promise.reject(
        new Error("Produkt-Handle fehlt.")
      );
    }

    if (productCache.has(handle)) {
      return productCache.get(handle);
    }

    const shopifyRoot =
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";

    const normalizedRoot =
      shopifyRoot.endsWith("/")
        ? shopifyRoot
        : shopifyRoot + "/";

    const productUrl =
      normalizedRoot +
      "products/" +
      encodeURIComponent(handle) +
      ".js";

    const request = fetch(productUrl, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        Accept: "application/json"
      }
    })
      .then(function (response) {
        if (!response.ok) {
          throw new Error(
            "Produktdaten konnten nicht geladen werden: " +
              response.status
          );
        }

        return response.json();
      })
      .catch(function (error) {
        productCache.delete(handle);
        throw error;
      });

    productCache.set(handle, request);

    return request;
  }

  function getMetafieldImageData(
    input,
    primaryImage
  ) {
    const imageSrc =
      input.dataset.variantMetafieldImage ||
      input.dataset.variantMetafieldImageRelativePath;

    if (!imageSrc) {
      return null;
    }

    const sourceWidth =
      getWidthFromUrl(imageSrc, 1200);

    const currentRatio =
      getCurrentImageRatio(primaryImage);

    const sourceHeight = Math.max(
      1,
      Math.round(sourceWidth / currentRatio)
    );

    return {
      src: getAbsoluteUrl(imageSrc),
      width: sourceWidth,
      height: sourceHeight,
      alt: primaryImage
        ? primaryImage.alt
        : ""
    };
  }

  function getVariantImageData(
    variant,
    productTitle
  ) {
    if (
      !variant ||
      !variant.featured_media ||
      !variant.featured_media.preview_image
    ) {
      return null;
    }

    const media = variant.featured_media;
    const previewImage =
      media.preview_image;

    return {
      src: getAbsoluteUrl(previewImage.src),
      width: previewImage.width,
      height: previewImage.height,
      alt: media.alt || productTitle || ""
    };
  }

  document.addEventListener(
    "change",
    async function (event) {
      if (!(event.target instanceof Element)) {
        return;
      }

      const input = event.target.closest(
        SWATCH_SELECTOR
      );

      if (!input || !input.checked) {
        return;
      }

      const wrapper = input.closest(
        ".js-color-swatches-wrapper"
      );

      if (!wrapper) {
        return;
      }

      const variantId = String(
        input.dataset.variantId || ""
      );

      const variantLink =
        input.dataset.variantLink || "";

      if (!variantId) {
        return;
      }

      wrapper.dataset.selectedVariantId =
        variantId;

      /*
       * Eine vorherige Bilduebergabe darf nicht auf die neu gewaehlte
       * Variante uebertragen werden. Sie wird unten mit dem passenden
       * Variantenbild neu gesetzt.
       */
      setSelectedVariantImageData(wrapper, null);

      /*
       * Ab jetzt wurde die Variante bewusst durch den Kunden gewaehlt.
       * Der sichtbare Link bleibt clean; die Varianten-ID wird erst beim
       * anschliessenden Produktklick im Browser zwischengespeichert.
       */
      wrapper.dataset.variantTransferEnabled =
        "true";

      updateProductLinks(
        wrapper,
        variantLink
      );

      updateQuickAdd(
        wrapper,
        variantId,
        !input.disabled
      );

      const primaryImage =
        wrapper.querySelector("img.media--first");

      const metafieldImage =
        getMetafieldImageData(
          input,
          primaryImage
        );

      if (metafieldImage) {
        setSelectedVariantImageData(
          wrapper,
          metafieldImage
        );

        await replacePrimaryImage(
          wrapper,
          input,
          metafieldImage
        );

        return;
      }

      const handle =
        wrapper.dataset.product;

      if (!handle) {
        return;
      }

      try {
        const product =
          await fetchProduct(handle);

        if (
          wrapper.dataset.selectedVariantId !==
          variantId
        ) {
          return;
        }

        const variant =
          product.variants.find(
            function (item) {
              return String(item.id) === variantId;
            }
          );

        if (!variant) {
          return;
        }

        updateQuickAdd(
          wrapper,
          variantId,
          variant.available !== false
        );

        const variantImage =
          getVariantImageData(
            variant,
            product.title
          );

        if (!variantImage) {
          return;
        }

        setSelectedVariantImageData(
          wrapper,
          variantImage
        );

        await replacePrimaryImage(
          wrapper,
          input,
          variantImage
        );
      } catch (error) {
        console.error(
          "Fehler beim Wechsel des Produktkartenbildes:",
          error
        );
      }
    }
  );
})();